import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import './CookiePolicy.css';

/**
 * CookiePolicy component - Displays the cookie policy using Termly embed
 * @returns {JSX.Element} The rendered cookie policy page with Termly iframe
 */
const CookiePolicy = () => {
  const navigate = useNavigate();

  /**
   * Loads the Termly embed script when component mounts
   */
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.id = 'termly-jssdk';
    script.src = 'https://app.termly.io/embed-policy.min.js';

    const existingScript = document.getElementById('termly-jssdk');
    if (!existingScript) {
      const firstScript = document.getElementsByTagName('script')[0];
      firstScript.parentNode.insertBefore(script, firstScript);
    }

    return () => {
      const scriptToRemove = document.getElementById('termly-jssdk');
      if (scriptToRemove) {
        scriptToRemove.remove();
      }
    };
  }, []);

  /**
   * Handles navigation back to previous page or home
   * @returns {void}
   */
  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="cookie-policy-container">
      <div className="cookie-policy-header">
        <button className="back-button" onClick={handleBack}>
          <FaArrowLeft />
        </button>
        <h1>Cookie Policy</h1>
      </div>
      <div className="cookie-policy-content">
        <div name="termly-embed" data-id="2ab749a5-b4c0-49d2-b2dc-ad312871cf49"></div>
      </div>
    </div>
  );
};

export default CookiePolicy;
